/*
 * @Author: Czy
 * @Date: 2024-09-19 18:29:18
 * @FilePath: /bikecat/src/store/hotel-search-poi.ts
 *
 */
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { FilterList, SearchObj, ELongHotelFilterDTO } from '@/service/hotel/hotel.d'

export interface PoiType {
  keyword: string
  type: string | number
  filterType: number
  filterId: number
}

export const useHotelPoiStore = defineStore(
  'searchPoi',
  () => {
    const filterList = ref<FilterList[]>([])
    // 住宿、设施数据
    const searchObj = ref<SearchObj>({
      lodgingSelectIds: [],
      facilitySelectIds: [],
      topicSelectIds: [],
      commentsSelectIds: [],
    })
    // 品牌数据
    const brandSelect = ref<ELongHotelFilterDTO[]>([])
    const selFiltersTypeIdTotal = ref(0) // 艺龙筛选项选中的显示总数
    const sort = ref('Default') // 艺龙默认排序

    // 酒店城市
    const poiBaseInfo = ref<Partial<PoiType>>({})

    const updatePoiInfo = (val: Partial<PoiType>) => {
      poiBaseInfo.value = {
        ...poiBaseInfo.value,
        ...val,
      }
    }

    const clearPoiInfo = () => {
      poiBaseInfo.value = {}
    }

    const setFilterList = (val: FilterList[]) => {
      filterList.value = val
    }
    const setSearchObj = (val: SearchObj) => {
      searchObj.value = val
    }
    const setBrandSelect = (val: ELongHotelFilterDTO[]) => {
      brandSelect.value = val
    }
    const setSelFiltersTypeIdTotal = (val: number) => {
      selFiltersTypeIdTotal.value = val
    }
    const setSort = (val: string) => {
      sort.value = val
    }
    const restFilterListData = () => {
      filterList.value = []
      searchObj.value = {
        lodgingSelectIds: [],
        facilitySelectIds: [],
        topicSelectIds: [],
        commentsSelectIds: [],
      }
      brandSelect.value = []
      selFiltersTypeIdTotal.value = 0
      sort.value = 'Default'
    }

    return {
      poiInfo: computed(() => poiBaseInfo.value),
      filterList,
      searchObj,
      brandSelect,
      selFiltersTypeIdTotal,
      sort,
      updatePoiInfo,
      clearPoiInfo,
      setFilterList,
      setSearchObj,
      setBrandSelect,
      setSelFiltersTypeIdTotal,
      setSort,
      restFilterListData,
    }
  },
  {
    persist: false,
  },
)
